import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */

export function initializeBlock(originalBlock) {
  let block = originalBlock;
  const blockId = originalBlock.id
  let swiper: Swiper | null = null;

  const initSwiper = () => {
    const swiperElement = block.querySelector('.wp-block-site-inspiration-carousel__swiper');

    if (!swiperElement) {
      return;
    }

    const nextEl = block.querySelector('.swiper-button-next');
    const prevEl = block.querySelector('.swiper-button-prev');

    swiper = new Swiper(swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.2,
      centeredSlides: false,
      loop: false,
      spaceBetween: 17,
      touchEventsTarget: 'container',

      // Navigation arrows
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },

      // And if we need scrollbar
      scrollbar: {
        el: ".swiper-scrollbar"
      },

      breakpoints: {
        768: {
        slidesPerView: 2,
        centeredSlides: false,
        },
      }
      });
  }

  initSwiper();

  const destroySwiper = () => {
    if (swiper) {
      swiper?.destroy(true, false)
      swiper = null;
    }
  }

  function isBlockHtmxEvent(evt) {
    // This is a outer htmx swap.
    if (blockId && evt.target.querySelector('#' + blockId)) {
      return true;
    }

    // This is a block htmx swap.
    if (blockId && blockId === evt.target.id) {
      return true;
    }

    // This is a inner htmx swap.
    if (evt.target.id && block.querySelector('#' + evt.target.id)) {
      return true;
    }

    return false;
  }

  function getBlockFromHtmxAfterSwapEvent(evt) {
    let queryBlock = blockId
      ? evt.target.querySelector('#' + blockId)
      : null;

    if (queryBlock) {
      return queryBlock;
    }

    if (blockId === evt.target.id) {
      return evt.target
    }

    return block;
  }

  const beforeSwap = function(evt) {
    if (!isBlockHtmxEvent(evt)) {
      return;
    }

    destroySwiper()
  }

  document.body.addEventListener('htmx:beforeSwap', beforeSwap);
  document.body.addEventListener('htmx:oobBeforeSwap', beforeSwap);

  const afterSwap = function(evt) {
    if (!isBlockHtmxEvent(evt)) {
      return;
    }

    block = getBlockFromHtmxAfterSwapEvent(evt);

    if (swiper) {
      destroySwiper()
    }

    initSwiper();
  }

  document.body.addEventListener('htmx:afterSwap', afterSwap);
  document.body.addEventListener('htmx:oobAfterSwap', afterSwap);
}
